export default {
  items: [
    {
      name: 'ড্যাশবোর্ড',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        // text: 'NEW'
      }
    },
    {
      name: 'হোল্ডিং নিবন্ধন',
      url: '/holding-registration',
      icon: 'fa fa-h-square'
    },

  ],
}
